import { useEffect } from "react";
import { AppTenantConfig } from "tenants/ThemeInjector";

export const BrandingHeader = () => {
    useEffect(() => {
        document.title = AppTenantConfig.brand.name

        const setLink = (rel, href) => {
            let link = document.querySelector(`link[rel='${rel}']`);
            if (!link) {
                link = document.createElement("link");
                link.rel = rel;
                document.head.appendChild(link);
            }
            link.href = href;
        };

        setLink("icon", AppTenantConfig.assets.favicon);
        setLink("manifest", AppTenantConfig.assets.manifest);
    }, [AppTenantConfig.brand.name, AppTenantConfig.assets.favicon, AppTenantConfig.assets.manifest]);

    return <></>;
};